import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"

const DataTableGroupe = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
   // Data Table
  const [orders, setOrders] = useState([])

  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    sizePerPage: 30,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "niveau",
      text: "Niveau",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "semestre",
      text: "semestre",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite",
      text: "Spécialité",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Groupes cours",
      isDummyField: true,
      text: "Groupes cours",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={"/ViewGroupCour?id=" + row.cyc_niv_sem_spec_id}>
            <i
              style={{ color: "darkmagenta", cursor: "pointer" }}
              className="fas fa-users-cog"
            ></i>
          </Link>
        </div>
      ),
    },
    {
      dataField: "Groupes TD",
      isDummyField: true,
      text: "Groupes TD",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={"/ViewGroupTD?id=" + row.cyc_niv_sem_spec_id}>
            <i
              style={{ color: "darkmagenta", cursor: "pointer" }}
              className="fas fa-users-cog"
            ></i>
          </Link>
        </div>
      ),
    },
    {
      dataField: "Groupes TP",
      isDummyField: true,
      text: "Groupes TP",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={"/ViewGroupTP?id=" + row.cyc_niv_sem_spec_id}>
            <i
              style={{ color: "darkmagenta", cursor: "pointer" }}
              className="fas fa-users-cog"
            ></i>
          </Link>
        </div>
      ),
    },
    // {
    //   dataField: "Consultation",
    //   isDummyField: true,
    //   text: "Consultation",
    //   style: { textAlign: "center" },
    //   headerStyle: (colum, colIndex) => {
    //     return { textAlign: "center" }
    //   },
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: (cellContent, row) => (
    //     <div style={{ display: "flex", justifyContent: "center" }}>
    //       <Link to={"/DetailGroupe?id=" + row.cyc_niv_sem_spec_id}>
    //         <i
    //           style={{ color: "darkcyan", cursor: "pointer" }}
    //           className="fas fa-eye"
    //         ></i>
    //       </Link>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "Modification",
    //   isDummyField: true,
    //   text: "Modification",
    //   style: { textAlign: "center" },
    //   headerStyle: (colum, colIndex) => {
    //     return { textAlign: "center" }
    //   },
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: (cellContent, row) => (
    //     <div style={{ display: "flex", justifyContent: "center" }}>
    //       <Link to={"/EditGroupe?id=" + row.cyc_niv_sem_spec_id}>
    //         <i
    //           style={{ color: "cornflowerblue", cursor: "pointer" }}
    //           className="fas fa-edit"
    //         ></i>
    //       </Link>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "Suppression",
    //   isDummyField: true,
    //   text: "Suppression",
    //   style: { textAlign: "center" },
    //   headerStyle: (colum, colIndex) => {
    //     return { textAlign: "center" }
    //   },
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: (cellContent, row) =>
    //     row.count == 0 ? (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         <i
    //           style={{ color: "#ED6464", cursor: "pointer" }}
    //           onClick={() => toggle(row.id)}
    //           className="fas fa-trash-alt"
    //         ></i>
    //       </div>
    //     ) : (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         <i
    //           style={{ color: "#a7a3a3", cursor: "pointer" }}
    //           className="fas fa-trash-alt"
    //           title="Ce groupe déja utilisé"
    //         ></i>
    //       </div>
    //     ),
    // },
  ]

  const { SearchBar } = Search

  useEffect(async () => {
      var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
      var annee_id = userAuthScolarite.user.annee_id
     const res = await API.post("group/list",{annee_id:annee_id}).then(res => {
      setOrders(res.data.Groups)
    })
    setLoading(true)
  }, [])

  const toggle = id => {
    setModal(!modal)
    setId(id)
  }

  const toggleDelete = async () => {
    const res = await API.post("group/delete", {
      id: id,
    }).then(res => {
      const resD = API.get("group/list").then(resD => {
        setModal(!modal)
        setOrders(resD.data.Groups)
      })
      setLoading(true)
    })
  }

  useEffect(() => {
    setModal(false)
  }, [orders])

  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {"Suppression d'un groupe"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer ce groupe ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(DataTableGroupe)
DataTableGroupe.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
}
